// extracted by mini-css-extract-plugin
export default {"scope":"iKPz8","convert-message":"EAwtB"};